import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Mail } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../services/ApiService';
import { ENDPOINTS } from '../constant/ApiEndpoints';

const ForgotPasswordModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault(); 
    if (!email) {
      toast.error("Please enter your email address.");
      return;
    }

    try {
      setIsLoading(true);
      const response = await api.post(ENDPOINTS.forgotPassword, { "identifier": email });
      const result = response?.data;
      if (response?.status == 200 || response?.status == 201) {
        toast.success(`Password reset link sent to ${email}`);
      }
    } catch (error) {
      console.error("forgot password error", error);
    } finally {
      setIsLoading(false);
      setEmail('');
      onClose();
    }
  };

  const backdropVariants = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 },
  };

  const modalVariants = {
    hidden: { y: "-50px", opacity: 0 },
    visible: { y: "0", opacity: 1, transition: { type: "spring", stiffness: 300, damping: 30 } },
    exit: { y: "50px", opacity: 0 },
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
          variants={backdropVariants}
          initial="hidden"
          animate="visible"
          exit="hidden"
          onClick={onClose}
        >
          <motion.div
            className="bg-white rounded-xl shadow-2xl p-8 w-full max-w-md"
            variants={modalVariants}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-bold font-display text-gray-800">Reset Password</h3>
              <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition">
                <X size={24} />
              </button>
            </div>
            <p className="text-gray-500 mb-6">
              Enter your email address and we'll send you a link to reset your password.
            </p>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="relative">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
                <input
                  type="email"
                  placeholder="Your Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-red/50 focus:border-brand-red outline-none transition-all"
                  required
                />
              </div>
              <button
              disabled={isLoading}
                type="submit"
                className="w-full bg-brand-red text-white py-3 rounded-lg font-semibold hover:bg-red-600 focus:outline-none focus:ring-4 focus:ring-brand-red/50 transition-all shadow-md hover:shadow-lg"
              >
              {isLoading ? 'Loading..' : 'Send Reset Link'}  
              </button>
            </form>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ForgotPasswordModal;
